import { assetUrl } from "../../utils/paths";
import {
  beginMaxxActionVerification,
  completeMaxxActionVerification,
} from "../../world-model/maxxActionVerification";

export function launchMaxxAr({ arUsdzUrl, arGlbUrl }) {
  beginMaxxActionVerification("launch_n2x_ar", { source: "ar_launcher" });
  const ua = navigator.userAgent || "";
  const isiOS =
    (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/.test(ua);
  const isFirefox = /firefox/i.test(ua);
  const isOculus = /OculusBrowser/.test(ua);
  const canAndroidAR = isAndroid && !isFirefox && !isOculus;

  if (isiOS) {
    if (!arUsdzUrl) {
      if (arGlbUrl) {
        completeMaxxActionVerification("launch_n2x_ar", {
          status: "pass",
          evidence: ["glb_fallback_navigation_started"],
          observedEffects: [{ type: "launch_ar", mode: "glb_fallback" }],
          boundary: "launcher_invocation_only",
        });
        window.location.href = arGlbUrl;
      } else {
        completeMaxxActionVerification("launch_n2x_ar", {
          status: "fail",
          evidence: ["ar_asset_missing"],
          observedEffects: [{ type: "ar_asset_missing" }],
          boundary: "launcher_invocation_only",
        });
      }
      return;
    }
    const link = document.createElement("a");
    link.rel = "ar";
    link.href = arUsdzUrl;
    link.style.display = "none";

    const img = document.createElement("img");
    img.src = assetUrl("/usdz.png");
    link.appendChild(img);

    document.body.appendChild(link);
    link.click();
    completeMaxxActionVerification("launch_n2x_ar", {
      status: "pass",
      evidence: ["ios_quick_look_launcher_invoked"],
      observedEffects: [{ type: "launch_ar", mode: "ios_quick_look" }],
      boundary: "launcher_invocation_only",
    });
    setTimeout(() => link.remove(), 1000);
    return;
  }

  if (canAndroidAR) {
    if (!arGlbUrl) return;
    const link = document.createElement("a");
    link.href =
      `intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(arGlbUrl)}#Intent;` +
      `scheme=https;package=com.google.android.googlequicksearchbox;` +
      `action=android.intent.action.VIEW;` +
      `S.browser_fallback_url=${encodeURIComponent(arGlbUrl)};end;`;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    completeMaxxActionVerification("launch_n2x_ar", {
      status: "pass",
      evidence: ["android_scene_viewer_launcher_invoked"],
      observedEffects: [{ type: "launch_ar", mode: "android_scene_viewer" }],
      boundary: "launcher_invocation_only",
    });
    setTimeout(() => link.remove(), 1000);
    return;
  }

  console.log("❌ AR not supported on this device/browser.");
  completeMaxxActionVerification("launch_n2x_ar", {
    status: "fail",
    evidence: ["ar_not_supported"],
    observedEffects: [{ type: "ar_not_supported" }],
    boundary: "launcher_invocation_only",
  });
}
